const actions = {
  GET_CORE_CONFIGS: 'GET_CORE_CONFIGS',
  GET_CORE_CONFIGS_ENDED: 'GET_CORE_CONFIGS_ENDED',
  UPLOAD_TEXT_EDITOR_IMAGE: 'UPLOAD_TEXT_EDITOR_IMAGE',
};

export default actions;
